import React from 'react';

import { cn } from '@/lib/utils';

import Button, { ButtonProps } from '@/components/atoms/Button';

export type IconButtonProps = {
  children: React.ReactNode;
} & ButtonProps;

// PS: 20px is padding (2x10px) + 24px/36px/48px is icon size
export const sizesOptions = ['s', 'm', 'l'] as const;
const sizes: Record<(typeof sizesOptions)[number], string> = {
  s: 'w-8 h-8',
  m: 'w-10 h-10',
  l: 'w-12 h-12',
};
const paddings: Record<(typeof sizesOptions)[number], string> = {
  s: 'p-2',
  m: 'p-3',
  l: 'p-3',
};

/**
 * For it to work with SVG React component you need to remove width and height from SVG file like in IconDownload.svg
 * Be aware that after removing it you will need to set width and height where that svg is used across the app
 */
export function IconButton({ children, classNames, ...rest }: IconButtonProps) {
  return (
    <Button
      classNames={{
        root: cn(
          'h-auto',
          paddings[rest?.size || 's'],
          sizes[rest?.size || 's'],
          classNames?.root
        ),
        inner: cn('h-full w-full', classNames?.inner),
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}
